import { Button, Input, Select } from '@chakra-ui/react';
import { TransportRequestSearch } from 'data/schemas/TransportRequest';

type Props = {
    onClickAddTransportRequest: () => void;
    onClickSearchTransportRequest: () => void;
    onClearSearchTransportRequest: () => void;
    searchValues: TransportRequestSearch;
    onSearchTransportRequest: <K extends keyof TransportRequestSearch>(
        key: K,
        value: TransportRequestSearch[K]
    ) => void;
};

function ActionPane(props: Props) {
    const {
        onClickAddTransportRequest,
        onClickSearchTransportRequest,
        onClearSearchTransportRequest,
        onSearchTransportRequest,
        searchValues
    } = props;
    const hasFilters = Boolean(
        searchValues.uatTag ||
            searchValues.developer ||
            searchValues.deploymentObject ||
            searchValues.deployStatus ||
            searchValues.ticket
    );

    return (
        <form
            onSubmit={event => {
                event.preventDefault();
                onClickSearchTransportRequest();
            }}
            className="flex flex-wrap items-end gap-3 rounded-md border bg-white p-3"
        >
            <div className="min-w-[170px] flex-1">
                <label htmlFor="tag">UAT Tag</label>
                <Input
                    id="tag"
                    value={searchValues.uatTag}
                    placeholder="Contains UAT tag"
                    onChange={event => onSearchTransportRequest('uatTag', event.target.value)}
                />
            </div>
            <div className="min-w-[170px] flex-1">
                <label htmlFor="developer">Developer</label>
                <Input
                    id="developer"
                    value={searchValues.developer}
                    placeholder="Contains developer ID"
                    onChange={event => onSearchTransportRequest('developer', event.target.value)}
                />
            </div>
            <div className="min-w-[170px] flex-1">
                <label htmlFor="file-name">File Name</label>
                <Input
                    id="file-name"
                    value={searchValues.deploymentObject}
                    placeholder="Contains file name"
                    onChange={event =>
                        onSearchTransportRequest('deploymentObject', event.target.value)
                    }
                />
            </div>
            <div className="min-w-[150px] flex-1">
                <label htmlFor="status">Status</label>
                <Select
                    id="status"
                    value={searchValues.deployStatus}
                    onChange={event => onSearchTransportRequest('deployStatus', event.target.value)}
                >
                    <option value="">All statuses</option>
                    <option value="Waiting">Waiting</option>
                    <option value="Online">Online</option>
                </Select>
            </div>
            <div className="min-w-[170px] flex-1">
                <label htmlFor="ticket">Ticket</label>
                <Input
                    id="ticket"
                    value={searchValues.ticket}
                    placeholder="Contains ticket"
                    onChange={event => onSearchTransportRequest('ticket', event.target.value)}
                />
            </div>
            <Button
                type="submit"
                colorScheme="blue"
            >
                Search
            </Button>
            <Button
                type="button"
                variant="outline"
                isDisabled={!hasFilters}
                onClick={onClearSearchTransportRequest}
            >
                Clear
            </Button>
            <div className="flex items-center gap-2">
                <label htmlFor="item">Items:</label>
                <select
                    id="item"
                    value={searchValues.pageSize}
                    onChange={event => onSearchTransportRequest('pageSize', event.target.value)}
                >
                    <option>15</option>
                    <option>25</option>
                    <option>35</option>
                    <option>45</option>
                </select>
            </div>
            <Button
                type="button"
                className="ml-auto"
                colorScheme="green"
                onClick={onClickAddTransportRequest}
            >
                Add TR (Transport Request)
            </Button>
        </form>
    );
}

export default ActionPane;
